"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
var en = {
  showTable: {
    totalPre: 'Total ',
    totalSuf: ' data',
    confirmDel: 'Confirm Delete?',
    delSuccess: 'Delete Succeeded',
    addSuccess: 'Add Succeeded',
    updateSuccess: 'Update Succeeded',
    action: 'Operations',
    view: 'view',
    edit: 'edit',
    del: 'delete',
    add: 'Add',
    export: 'Export',
    import: 'Import'
  },
  advanceFilter: {
    addFilter: 'Select',
    title: 'Search conditions',
    clear: 'Clear',
    filter: 'Filter',
    del: 'Delete'
  },
  showCols: {
    title: 'Show Fields',
    checkAll: 'Select all',
    searchCheckAll: 'Select all search results'
  },
  fullScreen: {
    title: 'Full Screen'
  },
  types: {
    includes: 'include',
    equals: 'equal to',
    notEqual: 'not equal to',
    range: 'Select range',
    gt: 'greater than',
    gte: 'Greater than or equal',
    lt: 'less than',
    lte: 'less than or equal'
  }
};
exports.en = en;